import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";

import type { SiteEvent } from "./TeamDashboard";

// Действия на страницах для «Что открывают и делают»: события Umami (`trackEvent`).
export const SITE_EVENT_LABELS: Record<SiteEvent, MessageDescriptor> = {
  analysis_section: msg`Opened an analysis section`,
  map_seek: msg`Moved time on the match map`,
  map_fullscreen: msg`Map in full screen`,
  ingest_download: msg`Clicked “Download” for the app`,
  invite_copy: msg`Copied an invite`,
  locale_switch: msg`Switched the language`,
  build_copy: msg`Copied a build name`,
  build_expand: msg`Opened build details`,
};
